import { template } from "@ember/template-compiler";
import MrcDiagnosticFields from '../mrc/diagnostic-fields';
import type { TOC } from '@ember/component/template-only';
interface Signature {
    Args: {
        form: unknown;
    };
}
const MyComponent: TOC<Signature> = template(`
  <MrcDiagnosticFields @form={{@form}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default MyComponent;
